import { render, staticRenderFns } from "./SwivleCard.vue?vue&type=template&id=01f37e90&scoped=true&"
import script from "./SwivleCard.vue?vue&type=script&lang=js&"
export * from "./SwivleCard.vue?vue&type=script&lang=js&"
import style0 from "./SwivleCard.vue?vue&type=style&index=0&id=01f37e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f37e90",
  null
  
)

export default component.exports